module.exports = __webpack_public_path__ + "img/icon_withdraw@2x.fd7d36eb.png";